import * as React from 'react';
import { CheckoutContextProvider } from './utils/CheckoutContext';
import CheckOutPage from './CheckOutPage';

const CheckOutWrapper = () => {
    return (
        <CheckoutContextProvider>
            <CheckOutPage />
        </CheckoutContextProvider>
    );
};

export default CheckOutWrapper;
